export const BSC_TESTNET = "bsc-testnet";
export const BSC_MAINNET = "bsc";
export const MANTLE_MAINNET = "mantle";
export const ARBITRUM = "arbitrum";

export const EXPLORER_URL = {
  [BSC_TESTNET]: "https://testnet.bscscan.com/",
  [BSC_MAINNET]: "https://bscscan.com/",
  [MANTLE_MAINNET]: "https://testnet.mantlescan.org/",
  [ARBITRUM]: "https://arbiscan.io/",
};

export const CHAIN_NAME_MAPPING = {
  [BSC_MAINNET]: "BNB Chain",
  [MANTLE_MAINNET]: "Mantle",
  [ARBITRUM]: "Arbitrum",
};

export const DEFAULT_CHAIN_NAME = MANTLE_MAINNET;

export const SUPPORTED_CHAINS = [BSC_MAINNET, MANTLE_MAINNET, ARBITRUM];

export const DATE_RANGE_OPTIONS = [
  {
    label: "Last Week",
    id: 1,
  },
  {
    label: "Last 2 Weeks",
    id: 2,
  },
  {
    label: "Last Month",
    id: 3,
    isDefault: true,
  },
  {
    label: "All time",
    id: 4,
  },
];

export const ALL_TIME_ID = DATE_RANGE_OPTIONS[DATE_RANGE_OPTIONS.length - 1].id;

export const DEFAULT_GROUP_PERIOD = 86400;

export const MOVING_AVERAGE_DAYS = 7;
export const MOVING_AVERAGE_PERIOD = 86400 * MOVING_AVERAGE_DAYS;

// all chain fields
export const ALL_CHAIN_CSV_FIELDS = [
  { key: MANTLE_MAINNET, name: CHAIN_NAME_MAPPING[MANTLE_MAINNET] },
  { key: BSC_MAINNET, name: CHAIN_NAME_MAPPING[BSC_MAINNET] },
  { key: ARBITRUM, name: CHAIN_NAME_MAPPING[ARBITRUM] },
  { key: "cumulative", name: "Cumulative" },
];

export const tokenSymbols = {
  [BSC_MAINNET]: {
    "0xe9e7cea3dedca5984780bafc599bd69add087d56": "BUSD",
    "0x2170ed0880ac9a755fd29b2688956bd959f933f8": "ETH",
    "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c": "BNB",
    "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c": "BTC",
    "0x55d398326f99059ff775485246999027b3197955": "USDT",
  },
  [MANTLE_MAINNET]: {
    "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111": "ETH",
    "0xcabae6f6ea1ecab08ad02fe02ce9a44f09aebfa2": "BTC",
    "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae": "USDT",
    "0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8": "MNT",
    "0xcda86a272531e8640cd7f1a92c01839911b90bb0": "METH",
  },
  [ARBITRUM]: {
    "0x82af49447d8a07e3bd95bd0d56f35241523fbab1": "ETH",
    "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f": "BTC",
    "0x912ce59144191c1204e64559fe8253a0e49e6548": "ARB",
    "0x2bcc6d6cdbbdc0a4071e48bb3b969b06b3330c07": "SOL",
    "0xf97f4df75117a78c1a5a0dbb814af92458539fb4": "LINK",
    "0xaf88d065e77c8cc2239327c5edb3a432268e5831": "USDC",
    "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8": "USGC.e",
  },
};

export const tokenDecimals = {
  [BSC_MAINNET]: {
    BUSD: 18,
    ETH: 18,
    BNB: 18,
    BTC: 18,
    USDT: 18,
  },
  [MANTLE_MAINNET]: {
    ETH: 18,
    BTC: 8,
    USDT: 6,
    MNT: 18,
    METH: 18,
  },
  [ARBITRUM]: {
    ETH: 18,
    BTC: 8,
    ARB: 18,
    SOL: 9,
    LINK: 18,
    USDC: 6,
    "USGC.e": 6,
  },
};

export const SUPPORTED_TOKENS = SUPPORTED_CHAINS.reduce((prev, cur) => {
  prev[cur] = Object.values(tokenSymbols[cur]);
  return prev;
}, {});

export const CHAIN_ID_MAPPING = {
  [MANTLE_MAINNET]: 5000,
  [BSC_MAINNET]: 56,
  [ARBITRUM]: 42161,
};

export const S3_URL_BASE = "https://storage.googleapis.com/ktx-data/data/";

export const THIRD_PARTY_EXCHANGE_CLIENT_MAP = {
  [BSC_MAINNET]:
    "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-bsc",
  [MANTLE_MAINNET]:
    "https://graphv3.fusionx.finance/subgraphs/name/fusionx/exchange-v3",
  [ARBITRUM]:
    "https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-minimal",
};

export const PLATFORM_TOKENS = {
  [BSC_MAINNET]: {
    KTC: "0x545356d4d69d8cD1213Ee7e339867574738751CA",
  },
  [MANTLE_MAINNET]: {
    KTC: "0x779f4E5fB773E17Bc8E809F4ef1aBb140861159a",
  },
  [ARBITRUM]: {
    KTC: "0x487f6baB6DEC7815dcd7Dfa2C44a8a17bd3dEd27",
  },
};
